var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnContinue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 215,
    height: 49,
    viewBox: "0 0 215 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shape \xC2\xB7 cut corner",
    d: "M0 0H203L215 12V49H0V0Z",
    fill: "#B8EE3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnContinue);
export default __webpack_public_path__ + "static/media/btn-continue.1c1c323898ab428ac25f9e7d43f48f34.svg";
export { ForwardRef as ReactComponent };